import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoatempotraveller() {



  const cardData =
  {
    keyword: 'Pune to Goa Tempo Traveller Hire ',
    heading: 'Sanavi Travels: Pune to Goa Tempo Traveller Hire',
    headingDescription: 'Sanavi Travels offers reliable Pune to Goa Tempo Traveller Hire, providing safe, comfortable, and hassle-free group travel for families, friends, corporate teams, and tour groups planning a memorable trip to Goa. Our well-maintained fleet of 9, 12, 13, 17, and 20 seater tempo travellers is ideal for long-distance journeys and vacation travel from Pune to Goa, featuring spacious seating, air-conditioned interiors, ample luggage space, and comfortable push-back seats. With experienced chauffeurs trained for highway and ghat routes, flexible one-way and round-trip hire options, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth, safe, and enjoyable journey. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to convenient drop-off at North Goa or South Goa locations, Sanavi Travels provides trusted Pune to Goa Tempo Traveller hire services for travelers seeking comfort, safety, and a reliable long-distance travel experience.',

    top: 'Top Places to Visit in Goa with Sanavi Travels',


   "topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of Goa’s most popular and lively beaches, known for its vibrant nightlife, beach shacks, and water sports. Visitors can enjoy parasailing, jet skiing, banana boat rides, and dolphin spotting tours. As the sun sets, the beach transforms into a buzzing hotspot with famous clubs, music, and seaside dining. Baga Beach perfectly represents Goa’s energetic and fun-loving spirit."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, often called the ‘Queen of Beaches’, is the largest and most crowded beach in North Goa. It offers a wide stretch of golden sand lined with resorts, restaurants, and shopping stalls. The beach is ideal for swimming, sunbathing, and water sports. Calangute’s lively atmosphere makes it a favorite among families, groups, and first-time visitors to Goa."
  },
  {
    "title": "Anjuna Beach",
    "description": "Anjuna Beach is famous for its bohemian vibe, rocky shoreline, and stunning sunsets. It is well known for the weekly Anjuna Flea Market, offering handicrafts, clothes, jewelry, and souvenirs. The beach has a relaxed charm with cafes and trance music heritage. Anjuna attracts backpackers, artists, and travelers seeking a laid-back coastal experience."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada is a 17th-century Portuguese fort overlooking the Arabian Sea, built to protect Goa from invasions. It houses one of the oldest lighthouses in Asia and offers panoramic views of the coastline. The fort’s massive laterite walls and historic charm make it a popular sightseeing spot. Fort Aguada is a perfect blend of history, architecture, and scenic beauty."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of the most important churches in India. It houses the mortal remains of St. Francis Xavier, attracting pilgrims from around the world. Built in baroque architectural style, the church reflects Goa’s Portuguese heritage. It stands as a symbol of faith, history, and cultural richness."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls is one of India’s tallest and most spectacular waterfalls, located on the Goa–Karnataka border. The four-tiered cascade resembles a river of milk flowing down the mountains, especially during monsoon. Visitors can reach the falls via jeep safari or trekking routes through dense forests. Dudhsagar is a must-visit destination for nature lovers and adventure seekers."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is known for its crescent-shaped shoreline, calm waters, and peaceful ambiance. It is ideal for swimming, kayaking, and relaxing in beach huts. Unlike the crowded North Goa beaches, Palolem offers tranquility and scenic beauty. The beach is perfect for couples and travelers seeking a serene coastal escape."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort gained popularity due to its appearance in Bollywood movies and offers breathtaking views of Vagator Beach and the Arabian Sea. The fort ruins sit atop a hill and are accessible by a short climb. It is a favorite spot for photography and sunset views. Chapora Fort combines cinematic fame with historical charm."
  },
  {
    "title": "Cruise on Mandovi River",
    "description": "A cruise on the Mandovi River is a popular Goan experience featuring music, dance, and scenic river views. Evening cruises offer live performances, folk dances, and illuminated cityscapes. Some cruises also provide casino entertainment onboard. Mandovi River cruises showcase Goa’s vibrant culture and relaxed lifestyle."
  },
  {
    "title": "Goa Nightlife & Beach Shacks",
    "description": "Goa is renowned for its electrifying nightlife, beach shacks, and party culture. Popular areas like Baga, Candolim, Anjuna, and Vagator come alive with music, DJ nights, and themed parties. Beach shacks serve delicious seafood, cocktails, and Goan cuisine. Goa’s nightlife makes it one of India’s top holiday and party destinations."
  }
],




   "services": [
    {
      "name": "Pune to Goa Tempo Traveller Hire",
      "description": "Pune to Goa Tempo Traveller Hire provides reliable and comfortable travel options for groups journeying from Pune to Goa. With well-maintained vehicles, spacious seating, and professional drivers, this service ensures a smooth highway journey. Ideal for family vacations, corporate outings, or group tours, passengers can relax and enjoy the scenic routes along the way. Flexible booking options and transparent pricing make it convenient for travelers planning their Goa trips."
    },
    {
      "name": "Goa Tempo Traveller Rental from Pune",
      "description": "Goa Tempo Traveller Rental from Pune offers hassle-free rental services for groups traveling to Goa. Vehicles are equipped for long-distance comfort, including ample legroom, luggage space, and air-conditioning. Professional chauffeurs ensure safe driving on highways and busy roads, while passengers enjoy a stress-free journey. Perfect for sightseeing, beach trips, or corporate travel, this service combines convenience, reliability, and affordability for all types of travelers."
    },
    {
      "name": "AC Tempo Traveller Pune to Goa",
      "description": "AC Tempo Traveller Pune to Goa ensures a cool and comfortable ride throughout the journey, making long-distance travel enjoyable for families, friends, and corporate groups. The air-conditioned interiors provide relief from heat, while spacious seating accommodates everyone comfortably. Experienced drivers follow optimized routes to minimize travel time and ensure a safe journey. This service is ideal for weekend getaways, vacation trips, or special occasions requiring a relaxing transfer from Pune to Goa."
    },
    {
      "name": "Luxury Tempo Traveller Goa Trip",
      "description": "Luxury Tempo Traveller Goa Trip offers premium vehicles with high-end interiors, ensuring an elegant and comfortable travel experience. Perfect for VIP trips, corporate outings, or special family vacations, these vehicles provide reclining seats, entertainment options, and ample luggage space. Professional chauffeurs manage the journey with punctuality and care, allowing passengers to focus on relaxation and sightseeing. The service combines style, comfort, and reliability for an unforgettable Goa trip."
    },
    {
      "name": "Family Tempo Traveller Goa",
      "description": "Family Tempo Traveller Goa caters specifically to families traveling together from Pune to Goa, ensuring safety, comfort, and convenience. Vehicles have spacious seating, child-friendly features, and sufficient luggage space for long trips. Experienced drivers follow safe routes and assist with any travel needs, making the journey stress-free. Ideal for vacations, holiday trips, or group family outings, this service provides a reliable and enjoyable experience for all age groups."
    },
    {
      "name": "Corporate Tempo Traveller Goa",
      "description": "Corporate Tempo Traveller Goa is designed for business groups traveling from Pune to Goa for conferences, meetings, or corporate events. Vehicles are equipped with premium interiors, spacious seating, and amenities for work or relaxation during the journey. Professional chauffeurs ensure timely pickups, safe driving, and a comfortable ride, allowing employees or executives to focus on their tasks or rest. Flexible billing and booking options cater to corporate requirements, making travel seamless and efficient."
    },
    {
      "name": "Tempo Traveller for Goa Tour Package",
      "description": "Tempo Traveller for Goa Tour Package provides convenient group transport for sightseeing and vacation trips in Goa. Vehicles are spacious, comfortable, and equipped with luggage-friendly interiors to accommodate tourists traveling with friends or family. Professional drivers ensure timely arrivals at popular attractions and follow optimized routes for a smooth journey. This service is ideal for holiday packages, guided tours, or group excursions, combining convenience, safety, and enjoyment throughout the trip."
    },
    {
      "name": "Affordable Pune to Goa Tempo Traveller",
      "description": "Affordable Pune to Goa Tempo Traveller offers budget-friendly travel options without compromising on comfort or safety. Well-maintained vehicles, professional drivers, and spacious seating ensure a stress-free journey. Ideal for students, family groups, or friends traveling on a budget, this service provides reliable and punctual transfers. Transparent pricing and easy booking make it accessible for travelers planning trips to Goa while keeping expenses under control."
    },
    {
      "name": "Chauffeur Driven Tempo Traveller Goa",
      "description": "Chauffeur Driven Tempo Traveller Goa provides experienced and professional drivers to ensure a smooth and stress-free journey from Pune to Goa. Passengers can relax during the trip, knowing that safety and punctuality are prioritized. Vehicles are spacious, comfortable, and suitable for groups of all sizes. This service is perfect for family vacations, group tours, or corporate travel, offering convenience, reliability, and peace of mind throughout the journey."
    },
    {
      "name": "Group Travel Tempo Traveller Goa",
      "description": "Group Travel Tempo Traveller Goa caters to large groups traveling from Pune to Goa, providing comfortable, spacious, and well-maintained vehicles. Whether for corporate outings, school trips, or family vacations, the service ensures everyone can travel together safely and efficiently. Professional drivers manage routes and schedules to optimize travel time, while passengers enjoy a smooth ride. Booking flexibility and transparent pricing make this an ideal choice for group travel."
    },
    {
      "name": "Best Tempo Traveller Pune to Goa",
      "description": "Best Tempo Traveller Pune to Goa offers top-quality vehicles and professional service for a superior travel experience. Comfortable interiors, skilled drivers, and attention to passenger convenience ensure a smooth journey from Pune to Goa. Suitable for families, friends, and corporate travelers, this service emphasizes punctuality, safety, and comfort. Passengers can enjoy the scenic highway route, relax during the trip, and arrive refreshed at their destination."
    },
    {
      "name": "Night Journey Tempo Traveller Goa",
      "description": "Night Journey Tempo Traveller Goa provides safe and comfortable vehicles for overnight travel from Pune to Goa. Experienced drivers navigate highways carefully, ensuring passenger safety during night trips. Vehicles are well-maintained with comfortable seating and ample space for luggage. This service is ideal for travelers preferring overnight journeys, maximizing daytime in Goa, and minimizing travel fatigue."
    },
    {
      "name": "Tempo Traveller for Friends Trip Goa",
      "description": "Tempo Traveller for Friends Trip Goa caters to groups of friends traveling together from Pune to Goa. Spacious interiors, luggage-friendly arrangements, and comfortable seating make the journey enjoyable. Professional drivers ensure safe and timely travel, allowing passengers to relax and enjoy the trip. Ideal for weekend getaways, holiday adventures, or long-distance group travel, this service combines fun, convenience, and comfort."
    },
    {
      "name": "Tempo Traveller Long Distance Travel",
      "description": "Tempo Traveller Long Distance Travel provides reliable and comfortable vehicles for long journeys from Pune to Goa. Designed for groups, families, and corporate travelers, these vehicles offer spacious seating, air-conditioning, and luggage storage. Professional drivers ensure safety, punctuality, and optimized travel routes. This service is perfect for holiday trips, weekend getaways, or multi-day tours, providing a stress-free travel experience."
    },
    {
      "name": "Pune Goa Travel Service",
      "description": "Pune Goa Travel Service offers comprehensive and reliable transport solutions for travelers moving between Pune and Goa. Vehicles are spacious, comfortable, and equipped for long-distance travel. Professional drivers ensure safety and timely arrivals, while flexible booking and transparent pricing make planning convenient. Ideal for families, corporate groups, friends, and tourists, this service guarantees a smooth, enjoyable, and memorable journey."
    }
  ],
  "tableData": [
    ["Pune to Goa Tempo Traveller Hire", "Goa Tempo Traveller Rental from Pune"],
    ["AC Tempo Traveller Pune to Goa", "Luxury Tempo Traveller Goa Trip"],
    ["Family Tempo Traveller Goa", "Corporate Tempo Traveller Goa"],
    ["Tempo Traveller for Goa Tour Package", "Affordable Pune to Goa Tempo Traveller"],
    ["Chauffeur Driven Tempo Traveller Goa", "Group Travel Tempo Traveller Goa"],
    ["Best Tempo Traveller Pune to Goa", "Night Journey Tempo Traveller Goa"],
    ["Tempo Traveller for Friends Trip Goa", "Tempo Traveller Long Distance Travel"],
    ["Pune Goa Travel Service", "—"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Goa Tempo Traveller Hire with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable Pune to Goa Tempo Traveller hire services, ideal for group vacations, family trips, corporate tours, and long-distance travel."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Tempo Travellers",
    "WhyChoosedescription": "Travel from Pune to Goa in spacious, air-conditioned, and well-maintained Tempo Travellers for a relaxed and enjoyable group journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long-Distance Routes",
    "WhyChoosedescription": "Our professional drivers are experienced with Pune to Goa routes, ensuring safe, smooth, and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Goa Tempo Traveller hire, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel planning, and journey-related queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized Tempo Traveller hire plans for your Pune to Goa trip."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every journey to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Goa Tempo Traveller hire."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Goa Tempo Traveller hire?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained Tempo Travellers for Pune to Goa travel.'
  },
  {
    question: 'How can I book a Pune to Goa Tempo Traveller with Sanavi Travels?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacities are available for Pune to Goa Tempo Traveller?',
    answer: 'We offer Tempo Travellers with different seating capacities suitable for small and large groups.'
  },
  {
    question: 'Are drivers included in the Tempo Traveller hire?',
    answer: 'Yes, all Tempo Traveller hires include experienced and professional drivers.'
  },
  {
    question: 'Is the Pune to Goa Tempo Traveller service available 24x7?',
    answer: 'Yes, our Tempo Traveller hire service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before the Pune to Goa trip?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I book a round-trip Tempo Traveller from Pune to Goa?',
    answer: 'Absolutely. Sanavi Travels offers both one-way and round-trip Tempo Traveller hire options.'
  },
  {
    question: 'What payment options are available for Pune to Goa Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the Pune to Goa journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Mehta',
    feedback: 'Our Pune to Goa trip with Sanavi Travels was fantastic. Comfortable Tempo Traveller, smooth drive, and very professional service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Nair',
    feedback: 'Excellent experience! Clean vehicle, experienced driver, and hassle-free journey to Goa.',
    rating: 5
  }
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Tempo Traveller Hire - Sanavi Travels",
  "description": "Pune to Goa tempo traveller hire by Sanavi Travels for family vacations, friends trips, corporate outings, and group travel. Choose AC and luxury tempo travellers for long-distance and night journey travel from Pune to Goa at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4127"
  }
};





  return (
    <div>


<Helmet>
  <title>
    Pune to Goa Tempo Traveller Hire Starting from ₹34 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Goa tempo traveller hire with Sanavi Travels. AC and luxury tempo traveller for Goa tour packages, family trips, friends travel, corporate and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoatempotraveller;